import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Flex, Layout, Typography } from 'antd'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import SpaceSwitcher, { useLoadMySpaces } from '@/components/SpaceSwitcher'
import { useRuntimeStore } from '@/store/useRuntimeStore'

function MainLayout() {
  const { t } = useTranslation()
  const location = useLocation()
  const isClient = useRuntimeStore((s) => s.isClient)
  useLoadMySpaces()

  const pathname = location.pathname.replace(/\/+$/, '') || '/'
  const isWorkbench = pathname === '/apps' || pathname === '/'

  return (
    <Layout
      className={isClient ? 'devplat-layout--client' : 'devplat-layout--browser'}
      style={{ minHeight: '100%' }}
    >
      {/* 对齐 org-console：PC 内嵌由宿主顶栏承载，本页不渲 header */}
      {!isClient && (
        <Layout.Header
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 24px',
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Flex align="center" gap={8}>
            <img src="/favicon.svg" alt="" className="h-7 w-7" />
            <Typography.Text strong>{t('common.appName')}</Typography.Text>
          </Flex>
          <div className="hdr-actions">
            <LanguageSwitcher />
            {isWorkbench && <SpaceSwitcher />}
          </div>
        </Layout.Header>
      )}
      <Layout.Content
        style={{
          padding: 24,
          ...(isWorkbench
            ? {
                display: 'flex',
                justifyContent: 'center',
              }
            : undefined),
        }}
      >
        {isWorkbench ? (
          <div style={{ width: '100%', maxWidth: 1200 }}>
            <Outlet />
          </div>
        ) : (
          <Outlet />
        )}
      </Layout.Content>
    </Layout>
  )
}

export default MainLayout
